<script setup lang="ts">
export interface Props {
  label?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
});
</script>

<template>
  <section
    :class="$style.advancedBookingFormSection"
    data-testid="advancedBookingFormSection"
  >
    <div v-if="props.label" :class="$style.header">{{ props.label }}</div>
    <div :class="$style.body">
      <slot />
    </div>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.advancedBookingFormSection {
  border: 1px solid colors.$color-gray-200;
  border-radius: 8px;
  overflow: hidden;
}

.header {
  background-color: colors.$color-brand-50;
  border-bottom: 1px solid colors.$color-gray-200;
  padding: 10px 24px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: colors.$color-text-primary;
}

.body {
  background-color: colors.$color-gray-50;
  padding: 1.5rem;
}
</style>
